/*
  Records the handle of every product page as it is visited, newest first,
  twenty at most, in the shopper's own browser. Loaded by the layout so it
  runs on every product page. The Recently viewed rows (collection-recent,
  with recent-cards.js) read this list.
*/
(() => {
  const KEY = 'recently-viewed';
  const MAX_STORED = 20;

  // Read from the path rather than the page markup, so recording does not
  // depend on the product template exposing anything.
  const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!match) return;
  const currentHandle = match[1];

  let handles = [];
  try {
    const stored = JSON.parse(localStorage.getItem(KEY));
    if (Array.isArray(stored)) handles = stored;
  } catch (error) {
    // Nothing stored yet, or storage unavailable.
  }

  handles = handles.filter((handle) => handle !== currentHandle);
  handles.unshift(currentHandle);

  try {
    localStorage.setItem(KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
  } catch (error) {
    // Private browsing or storage disabled. Recording is optional.
  }
})();
